import { readReviewerIdentity } from "./mockupApi";

const ENDPOINT_BASE = process.env.REACT_APP_MOCKUP_COMMENT_ENDPOINT || "";
const AGENT_ID = "mockup-editor";

const ensureEndpointConfigured = () => {
  if (ENDPOINT_BASE) return;
  throw new Error(
    "REACT_APP_MOCKUP_COMMENT_ENDPOINT is not set. Add it to the front-end Doppler config.",
  );
};

const buildUrl = (fnName) => `${ENDPOINT_BASE.replace(/\/$/, "")}/${fnName}`;

const parseSseFrame = (frame) => {
  const dataLine = frame.split("\n").find((line) => line.startsWith("data: "));
  if (!dataLine) return null;
  try {
    return JSON.parse(dataLine.slice("data: ".length));
  } catch {
    return null;
  }
};

const pumpSseStream = async ({ reader, decoder, onEvent, buffer }) => {
  const { done, value } = await reader.read();
  if (done) return;
  const nextBuffer = buffer + decoder.decode(value, { stream: true });
  const frames = nextBuffer.split("\n\n");
  const remainder = frames[frames.length - 1] || "";
  const completeFrames = frames.slice(0, -1);
  completeFrames.filter(Boolean).map(parseSseFrame).filter(Boolean).forEach(onEvent);
  await pumpSseStream({ reader, decoder, onEvent, buffer: remainder });
};

const streamFromEndpoint = async ({ fnName, body, onEvent }) => {
  ensureEndpointConfigured();
  const response = await fetch(buildUrl(fnName), {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(body),
  });
  if (!response.ok || !response.body) {
    const text = await response.text().catch(() => "");
    throw new Error(`${fnName} failed (${response.status}) ${text.slice(0, 200)}`);
  }
  const reader = response.body.getReader();
  const decoder = new TextDecoder();
  await pumpSseStream({ reader, decoder, onEvent, buffer: "" });
};

const streamAgentChat = ({ threadId, message, pageContext, onEvent }) => {
  const { email: reviewerEmail } = readReviewerIdentity();
  return streamFromEndpoint({
    fnName: "agentChat",
    body: { agentId: AGENT_ID, threadId, message, pageContext, reviewerEmail },
    onEvent,
  });
};

const streamAgentApprove = ({ pendingId, approved, rejectionReason, onEvent }) => {
  const { email: reviewerEmail } = readReviewerIdentity();
  return streamFromEndpoint({
    fnName: "agentApprove",
    body: { agentId: AGENT_ID, pendingId, approved, rejectionReason, reviewerEmail },
    onEvent,
  });
};

const fetchLiveSession = async ({ hillId }) => {
  ensureEndpointConfigured();
  const params = new URLSearchParams({ hillId });
  const response = await fetch(`${buildUrl("getMockupLiveSession")}?${params.toString()}`, {
    method: "GET",
  });
  if (!response.ok) return { pendingOverrides: {} };
  const data = await response.json().catch(() => ({ pendingOverrides: {} }));
  return { pendingOverrides: data.pendingOverrides || {} };
};

export { streamAgentChat, streamAgentApprove, fetchLiveSession };
